import { Link } from 'react-router-dom';
import { ChevronRight, AudioLines } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { SOUND_LESSONS } from '../lib/soundLessons';
import { useAuth } from '../contexts/AuthContext';

// Every sound lesson in one place, reached from the menu (Leanne, 27 Oct
// 2026). Each lesson is also linked from the sounds it covers on the session
// summary and the dashboard.
export default function SoundLessons() {
    const { user } = useAuth();
    if (!user?.sound_lessons) {
        return <div className="p-8 text-center text-stone-500">Sound lessons are not available yet.</div>;
    }
    const lessons = Object.values(SOUND_LESSONS);
    return (
        <div className="max-w-2xl mx-auto px-4 py-6 md:py-10" data-testid="sound-lessons">
            <h1 className="text-2xl font-semibold text-foreground mb-1">Sound lessons</h1>
            <p className="text-sm text-stone-500 mb-6">
                The French sounds English speakers find hardest. Listen, compare, then practise them in phrases.
            </p>
            <div className="space-y-3">
                {lessons.map(l => (
                    <Link key={l.id} to={`/sounds/${l.id}`} className="block" data-testid={`sound-lesson-${l.id}`}>
                        <Card className="bg-white border-stone-100 shadow-sm hover:border-primary/40 transition-colors">
                            <CardContent className="p-4 flex items-center gap-3">
                                <span className="w-9 h-9 rounded-lg bg-primary/10 text-primary flex items-center justify-center flex-shrink-0">
                                    <AudioLines className="h-4 w-4" />
                                </span>
                                <span className="flex-1 min-w-0">
                                    <span className="block text-base font-semibold text-foreground">
                                        {l.versus ? `${l.versus[0]} vs ${l.versus[1]}` : l.titleMain}
                                    </span>
                                    <span className="block text-sm text-stone-500 truncate">
                                        {l.hear.flatMap(g => g.words).slice(0, 6).join(', ')}
                                    </span>
                                </span>
                                <ChevronRight className="h-5 w-5 text-stone-400 flex-shrink-0" />
                            </CardContent>
                        </Card>
                    </Link>
                ))}
            </div>
        </div>
    );
}
